import ApiService from "./apiservice";

export const ConfigService = {
    getYears() {
        return ApiService.get("getYears");
    },
    loadConfig() {
        return ApiService.get("loadConfig");
    },
    saveConfig(params) {
        return ApiService.post("saveConfig", null, params);
    },
    canActiveLock() {
        return ApiService.get("canActiveLock");
    },
    canDeActiveLock() {
        return ApiService.get("canDeActiveLock");
    },
    AutoUpdate() {
        return ApiService.get("AutoUpdate");
    },
    ChangeDb() {
        return ApiService.get("ChangeDb");
    },
    ChangeYearDb() {
        return ApiService.get("ChangeYearDb");
    },
    ChangeTable() {
        return ApiService.get("ChangeTable");
    },
    ActiveLockByWeb(params) {
        //string productCode
        return ApiService.post("ActiveLockByWeb",null,params);
    },
    DeActiveLockByWeb() {
        return ApiService.post("DeActiveLockByWeb");
    },
    ActiveLockByFile(formData) {
        return ApiService.postFormData("ActiveLockByFile",formData);
    },
    loadLockAvtivation() {
        return ApiService.get("loadLockAvtivation");
    },
    NeedUpdateDB() {
        return ApiService.get("NeedUpdateDB");
    },
    hasActiveYearDb() {
        return ApiService.get("hasActiveYearDb");
    },
    IsWinkartUpToDate() {
        return ApiService.get("IsWinkartUpToDate");
    },

};